export * from './isFunction'
export * from './isInBrowser'
